<template>
  <div id="q-app" class="bg-container column justify-start" :style="{ backgroundImage: `url(${bgImage})` }">
    <q-img src="" class="hidden"></q-img> <!-- 保留 q-img 占位，避免 quasar q-img 影响布局 -->

    <div class="row justify-center">
      <q-card class="col-auto column justify-center q-pa-md" v-if="show_login"
        style="margin-top: 80px; background-color: #F2F2F2;">
        <div class="row self-center">
          <q-avatar square size="70px">
            <img src="@/assets/img/logo128.png" />
          </q-avatar>
        </div>

        <div class="row self-center text-h4">{{ login_title }}</div>
        <div class="row self-center text-h8">{{ login_sub_title }}</div>

        <div class="q-pa-md self-center" style="min-width: 400px">
          <q-form dense @submit="onSubmit" @reset="onReset">
            <q-input v-if="is_show_org" ref="org_code" :dense="$form['dense']" :outlined="$form['outlined']"
              v-model="dataForm.org_code" lazy-rules class="form_item full-width"
              :prefix="$form['is_label_in'] ? $t('org') + '：' : null"
              :rules="[(val) => !!val || $t('please_enter_org')]">
              <template v-if="!$form['is_label_in']" v-slot:before>
                <div class="form_item_label">{{ $t("org") + "：" }}</div>
              </template>
            </q-input>

            <q-input ref="user_name" :dense="$form['dense']" :outlined="$form['outlined']" v-model="dataForm.user_name"
              lazy-rules class="form_item full-width" :prefix="$form['is_label_in'] ? $t('login_name') + '：' : null"
              :rules="[(val) => !!val || $t('please_enter_login_name')]">
              <template v-if="!$form['is_label_in']" v-slot:before>
                <div class="form_item_label">{{ $t("login_name") + "：" }}</div>
              </template>
            </q-input>

            <q-input ref="password" :dense="$form['dense']" :outlined="$form['outlined']" type="password"
              v-model="dataForm.password" lazy-rules class="form_item"
              :prefix="$form['is_label_in'] ? $t('password') + '：' : null"
              :rules="[(val) => !!val || $t('please_enter_password')]">
              <template v-if="!$form['is_label_in']" v-slot:before>
                <div class="form_item_label">{{ $t("password") + "：" }}</div>
              </template>
            </q-input>

            <div class="row justify-center content-center q-mt-xm">
              <div class="col-6 text-center">
                <q-checkbox v-model="dataForm.remember_login_name" :label="$t('remember_login_name')"></q-checkbox>
              </div>
              <div class="col-6 text-center">
                <q-checkbox v-model="dataForm.remember_password" :label="$t('remember_password')"></q-checkbox>
              </div>

              <q-btn class="full-width q-mt-md" :label="$t('login')" type="submit" color="primary"></q-btn>
            </div>

            <div class="q-mt-sm">
              <q-select v-if="lang_items.length > 0" standout v-model="current_lang" :options="lang_items" dense
                @update:model-value="change_language">
                <template v-slot:prepend>
                  <q-icon name="fas fa-globe" />
                </template>
              </q-select>
            </div>
          </q-form>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, ref } from "vue";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { request } from "@/request/api";
import PublicFunction from "@/utils/PublicFunction.js";
import bgImg from "/src/assets/img/login_bg.jpg"; // 背景图片

export default {
  name: "Login",
  setup() {
    const internalInstance = getCurrentInstance();
    const global = internalInstance?.appContext.config.globalProperties;

    const $q = useQuasar();
    const router = useRouter();
    const { locale, t } = useI18n();
    // const { save_operation_log } = PublicFunction;

    const bgImage = bgImg;
    const show_login = ref(false);
    const login_title = ref("");
    const login_sub_title = ref("");
    const is_show_org = ref(false);

    const current_lang = ref(null);
    const lang_items = ref([]);

    const dataForm = ref({
      password: "",
      user_name: "",
      remember_login_name: false,
      remember_password: false,
      org_code: "",
      login_goto: "back",
    });

    // 初始化表单
    if ($q.localStorage.has("org_code")) dataForm.value.org_code = $q.localStorage.getItem("org_code");
    if ($q.localStorage.has("user_name")) {
      dataForm.value.user_name = $q.localStorage.getItem("user_name");
      dataForm.value.remember_login_name = true;
    }
    if ($q.localStorage.has("password")) {
      dataForm.value.password = $q.localStorage.getItem("password");
      dataForm.value.remember_password = true;
    }
    if ($q.localStorage.has("permission")) $q.localStorage.remove("permission");

    try {
      login_title.value = $q.localStorage.getItem("my_param")["login_title"];
      login_sub_title.value = $q.localStorage.getItem("my_param")["login_sub_title"];
      locale.value = $q.localStorage.getItem("my_param")["language"];

      if ($q.localStorage.getItem("my_param")["language_list"]) {
        lang_items.value = JSON.parse($q.localStorage.getItem("my_param")["language_list"]);
        current_lang.value = { label: lang_items.value[0].label, value: lang_items.value[0].value };
      } else {
        if ($q.localStorage.has("current_lang")) {
          $ql.localStorage.remove("current_lang");
        }
        current_lang.value = locale.value;
      }

      if ($q.localStorage.has("current_lang")) {
        current_lang.value = $q.localStorage.getItem("current_lang");
        locale.value = current_lang.value["value"];
      }

      is_show_org.value =
        typeof $q.localStorage.getItem("my_param")["is_show_org"] !== "undefined"
          ? $q.localStorage.getItem("my_param")["is_show_org"]
          : false;

      dataForm.value["org_code"] = is_show_org.value ? dataForm.value["org_code"] : "";
      show_login.value = true;
    } catch (error) {
      location.reload();
    }

    function change_language() {
      locale.value = current_lang.value["value"];
      $q.localStorage.set("current_lang", current_lang.value);
    }

    function onSubmit() {
      request("check_login", dataForm.value).then((res) => {
        // 登录失败
        if (res.status !== true) {
          $q.notify({
            type: "warning",
            message: t(res.msg),
            position: "top",
          });
          return;
        }

        const { user_info, permission } = res;

        // 操作日志
        // save_operation_log(
        //   user_info.user_id,
        //   user_info.nickname,
        //   "login",
        //   "LOGIN",
        //   "Success"
        // );
        // save_operation_log(
        //   user_info.user_id,
        //   user_info.nickname,
        //   t("login"),
        //   t("login"),
        //   "Success;"
        // );

        // 登录成功提示
        $q.notify({
          color: "secondary",
          textColor: "white",
          icon: "fa fa-check",
          message: t("login_success"),
          position: "top",
        });

        // 记住用户名
        if (dataForm.value.remember_login_name) {
          $q.localStorage.set("user_name", dataForm.value.user_name);
        } else {
          dataForm.value.user_name = "";
        }

        // 记住密码
        if (dataForm.value.remember_password) {
          $q.localStorage.set("password", dataForm.value.password);
        } else {
          dataForm.value.password = "";
        }

        // 设置用户信息 & 权限
        $q.localStorage.set("org_code", dataForm.value.org_code);
        $q.localStorage.set("user_info", user_info);
        $q.localStorage.set("permission", permission);
        $q.localStorage.set("login_now", true);
        $q.localStorage.set("login_first", true);

        // 跳转页面
        router.replace({
          name: res.user_info.is_front === 1 ? "Front_rms" : "Main",
        });
      });
    }

    function onReset() {
      dataForm.value.user_name = "";
      dataForm.value.password = "";
      dataForm.value.remember_login_name = false;
      dataForm.value.remember_password = false;
    }

    return {
      bgImage,
      show_login,
      login_title,
      login_sub_title,
      is_show_org,
      dataForm,
      current_lang,
      lang_items,
      change_language,
      onSubmit,
      onReset,
      t,
    };
  },
};
</script>

<style>
.bg-container {
  width: 100vw;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: top center;
  /* 顶部垂直居中 */
  background-size: cover;
  /* 最小边铺满，长边等比缩放 */
}
</style>
